// AUTO-GENERATED by packages/db/scripts/port-i18n-m2.ts — do not hand-edit
// structure. Adding a NEW key here is fine (that's the point: code defaults).
// DB rows in `translations` override these at boot, same language only.
//
// Locale: en

export const en = {
  app: {
    account: {
      danger_title: 'Delete account',
      delete_button: 'Delete my account',
      delete_confirm_label: 'Type {word} to confirm',
      delete_confirm_word: 'DELETE',
      delete_description:
        'This removes your name, email and sign-in details, and closes your children’s accounts. It cannot be undone.',
      delete_dialog_title: 'Delete your account?',
      delete_error_subscription:
        'Cancel your subscription first, then come back to delete your account.',
      delete_kept:
        'Your billing records are kept, as the law requires. They are no longer linked to your name.',
      delete_password_label: 'Confirm with your password',
      delete_submit: 'Permanently delete',
      delete_warning: 'This is permanent. Please read it carefully.',
      email_current: 'Current email',
      email_description:
        'We will send a confirmation link to your new address. Your current one keeps working until you click it.',
      email_error_same: 'That is already your email address.',
      email_error_taken: 'That email address is not available.',
      email_label: 'New email address',
      email_sent: 'Check your new inbox for a confirmation link.',
      email_submit: 'Send confirmation link',
      email_title: 'Email address',
      email_verified_success: 'Your email address has been updated.',
      email_verifying: 'Confirming your new email address…',
      export_button: 'Download my data',
      export_description:
        'Download a copy of your account details, your children’s records and your billing history.',
      export_error: 'We could not prepare your download. Please try again.',
      export_ready: 'Your download has started.',
      export_title: 'Your data',
      language_description: 'The language used across the app and in the emails we send you.',
      language_title: 'Language',
      password_current_label: 'Current password',
      password_description: 'Changing your password signs you out on every other device.',
      password_error_same: 'The new password must be different from your current one.',
      password_error_wrong: 'That current password is not correct.',
      password_label: 'New password',
      password_repeat_label: 'Repeat new password',
      password_repeat_mismatch: 'The two passwords do not match.',
      password_submit: 'Change password',
      password_success: 'Your password has been changed.',
      password_title: 'Password',
      saved: 'Saved',
      subtitle: 'Manage your sign-in details, language and data.',
      title: 'Account settings',
    },
    auth: {
      create_account: 'Create account',
      email_label: 'Email',
      have_account: 'Already have an account?',
      magic_link: 'Email me a sign-in link instead',
      magic_sent: 'If that email is in our system, a sign-in link is on its way.',
      marketing_opt_in: 'Send me occasional tips and new-story announcements.',
      name_label: 'Your name',
      no_account: 'New to Fajr Arabi?',
      password_hint_parent: 'At least 10 characters, with a letter and a number.',
      password_label: 'Password',
      school_tab: 'School',
      sign_in: 'Sign in',
      sign_in_failed: "That didn't match. Check your details and try again.",
      sign_in_link: 'Sign in',
      sign_up_link: 'Create a family account',
      signup_subtitle:
        'Create a parent account. Add your children once you are in — no card needed to start.',
      signup_title: 'Create your account',
      tab_kid: "I'm a learner",
      tab_parent: "I'm a parent",
      username_label: 'Username',
      welcome_subtitle: 'Sign in to continue your learning journey.',
      welcome_title: 'Welcome back',
    },
    badges: {
      earned_on: 'Earned {date}',
      empty: 'No badges yet — keep learning!',
      locked: 'Not earned yet',
      new_badge: 'New badge!',
      subtitle: '{earned} of {total} badges earned',
      title: 'My achievements',
    },
    billing: {
      activity: 'All activity',
      activity_hide: 'Hide activity',
      activity_none: 'No activity yet.',
      activity_show: 'Show all activity',
      back_to_billing: 'Back to billing',
      cancel: 'Cancel',
      card_brand_unknown: 'Card',
      card_default: 'Default',
      card_expired: 'Expired',
      card_expires: 'Expires {month}/{year}',
      card_expiring_soon: 'Expiring soon',
      card_last4: '{brand} ending in {last4}',
      card_make_default: 'Make default',
      card_none: 'No card saved yet.',
      card_none_warning: 'No card is saved. Your subscription cannot renew without one.',
      card_remove: 'Remove',
      card_remove_confirm: 'Remove {brand} ending in {last4}?',
      card_remove_confirm_body: 'This card will no longer be used for renewals.',
      card_update: 'Update card',
      card_updated: 'Your card was updated.',
      checkout_canceled: 'Checkout was not completed. No charge was made.',
      checkout_success: 'Payment received — your subscription is active.',
      choose: 'Choose',
      choose_plan: 'Choose a plan',
      coupon_applied: 'Coupon {code}',
      coupon_label: 'Have a coupon?',
      coupon_placeholder: 'Coupon code',
      currency: 'Currency',
      current_plan: 'Current plan',
      discount: 'Discount',
      ends_on: 'Ends on {date}',
      invoice_amount: 'Amount',
      invoice_date: 'Date',
      invoice_not_found: 'We couldn’t find that invoice.',
      invoice_number: 'Invoice {number}',
      invoice_paid_on: 'Paid on {date}',
      invoice_plan: 'Plan',
      invoice_print: 'Print',
      invoice_refunded_amount: 'Refunded',
      invoice_status: 'Status',
      invoice_view: 'View invoice',
      invoices: 'Invoices',
      monthly: 'Monthly',
      most_popular: 'Most popular',
      no_subscription: 'You’re not subscribed yet. Pick a plan to get started.',
      payment_method: 'Payment method',
      per_month: 'month',
      per_year: 'year',
      refund_on: 'Refunded on {date}',
      refund_reason: 'Reason',
      refunds: 'Refunds',
      refunds_none: 'No refunds on this invoice.',
      renews_on: 'Renews on {date}',
      resume: 'Resume',
      status_active: 'Active',
      status_canceled: 'Canceled',
      status_draft: 'Draft',
      status_incomplete: 'Incomplete',
      status_open: 'Open',
      status_paid: 'Paid',
      status_partially_refunded: 'Partially refunded',
      status_past_due: 'Past due',
      status_refunded: 'Refunded',
      status_trialing: 'Trial',
      status_uncollectible: 'Unpaid',
      status_void: 'Void',
      subtotal: 'Subtotal',
      title: 'Plan & billing',
      total: 'Total',
      txn_invoice: 'Subscription payment',
      txn_refund: 'Refund',
      yearly: 'Yearly',
    },
    certificate: {
      awarded_to: 'Awarded to',
      body: 'for successfully completing all {lessons} lessons of',
      heading: 'Certificate of completion',
      lessons_done: '{n} lessons completed',
      not_earned: 'Finish every lesson in the unit to earn this certificate.',
      print: 'Print',
      print_hint: 'Tip: choose “Save as PDF” in the print dialog to keep a copy.',
      section_title: 'My certificates',
      view: 'View',
    },
    common: {
      app_name: 'Fajr Arabi',
      cancel: 'Cancel',
      error_generic: 'Something went wrong. Please try again.',
      lang_switch_label: 'Change language',
      loading: 'Loading…',
      pick_role_subtitle: 'You have more than one role. Pick one to continue.',
      pick_role_title: 'Choose how to continue',
      role_kid: 'Learner',
      role_parent: 'Parent',
      role_school_admin: 'School admin',
      role_switcher_label: 'Switch role',
      role_teacher: 'Teacher',
      save: 'Save',
      sign_out: 'Sign out',
    },
    consent: {
      accept_all: 'Accept all',
      analytics_desc: 'Helps us understand which pages and lessons work well.',
      analytics_label: 'Analytics',
      body: 'We use essential cookies to run this app. With your permission, we also measure how it is used and how our ads perform. You can change your choice at any time.',
      customize: 'Customise',
      essential_only: 'Essential only',
      marketing_desc: 'Lets our advertising partners measure whether their ads brought you here.',
      marketing_label: 'Marketing',
      save: 'Save choices',
      title: 'Your privacy',
    },
    kid: {
      all_done_body: 'You finished your lessons. Come back later for more.',
      all_done_title: 'All done for now!',
      assigned_done: 'Done',
      assigned_start: 'Start',
      assigned_title: 'Your tasks',
      coming_soon: 'Your first lesson is being prepared. Come back very soon!',
      continue_lesson: 'Keep going',
      greeting: 'Hi {name}!',
      lesson_minutes: 'About {n} min',
      load_error: "We couldn't load your lesson. Pull to refresh.",
      start_lesson: 'Start',
      streak: '{n}-day streak',
      todays_plan: "Today's adventure",
      xp: '{n} XP',
    },
    messages: {
      compose_placeholder: 'Write a message…',
      empty: 'No conversations yet.',
      held_for_review: 'Held for review',
      message_label: 'Message',
      mode_broadcast: 'To a class',
      mode_direct: 'To a student',
      no_messages_yet: 'No messages yet',
      observer_badge: 'Watching',
      pick_class: 'Class',
      pick_conversation: 'Pick a conversation to read it.',
      pick_student: 'Student',
      read_only: 'This conversation is read-only for you.',
      send: 'Send',
      send_broadcast: 'Send to class',
      title: 'Messages',
    },
    nav: {
      assignments: 'Assignments',
      badges: 'Badges',
      billing: 'Billing',
      classes: 'Classes',
      home: 'Home',
      kids: 'Children',
      map: 'Map',
      messages: 'Messages',
      overview: 'Overview',
      plan: 'Plan',
      profile: 'Me',
      progress: 'Progress',
      settings: 'Settings',
      stories: 'Stories',
      students: 'Students',
      tasks: 'Tasks',
      teachers: 'Teachers',
      today: 'Today',
    },
    notif: {
      bell_label: 'Notifications',
      empty: 'Nothing new.',
      push_label: 'Push notifications',
      push_off: 'Off',
      push_on: 'On',
      title: 'Notifications',
    },
    parent: {
      add_kid: 'Add a child',
      add_kid_title: 'Add a child',
      coming_soon_progress:
        'Detailed progress and rewards arrive soon. For now, add your children and hand them the tablet.',
      dashboard_subtitle: "Here's how your family's learning is going.",
      delete_kid: 'Remove',
      delete_kid_confirm:
        'Remove {name}? Their progress will be archived and they will no longer be able to sign in.',
      edit_kid: 'Edit',
      edit_kid_title: 'Edit child',
      field_avatar: 'Choose an avatar',
      field_display_name: "Child's name",
      field_grade: 'Grade',
      field_password: 'Password',
      field_password_hint: 'At least 6 characters, including a letter.',
      field_username: 'Username',
      field_username_hint: 'Letters, digits, dot and underscore. This is how they sign in.',
      grade_none: 'Not set',
      greeting: 'Hello, {name}',
      kid_cap_note: 'Your plan supports up to 3 children.',
      kids_subtitle: 'Add a profile for each child. They sign in with a username and password.',
      kids_title: 'Your children',
      no_kids: 'No children yet. Add your first to get started.',
      open_as: 'Open as {name}',
      reset_password: 'Reset password',
      username_available: 'Available',
      username_taken: 'Taken — try one of these:',
    },
    paywall: {
      locked_body: 'You’ve finished the free lessons. Ask a grown-up to unlock the rest.',
      locked_title: 'Keep going!',
      nudge_body:
        'Your kids can explore the free lessons now. Subscribe to open every unit, subject and printable.',
      nudge_cta: 'See plans',
      nudge_title: 'Unlock the full curriculum',
      parent_unlock: 'Unlock all lessons',
      trial_badge: 'Free plan',
    },
    progress: {
      activity_title: 'Activity (12 weeks)',
      all_time: 'All time',
      empty_activity: 'No activity yet — play a lesson to see this fill in.',
      freeze_used: 'Freeze used this week',
      last_active: 'Last active',
      last_login: 'Last sign-in',
      lessons: 'Lessons',
      lessons_completed: '{n} completed',
      minutes: '{n} min',
      never: 'Not yet',
      no_kids: 'Add a child first to track progress.',
      pick_kid: 'Choose a child to see their progress.',
      streak: 'Streak',
      streak_current: '{n}-day streak',
      streak_longest: 'Best: {n} days',
      subjects_title: 'By subject',
      this_month: 'This month',
      this_week: 'This week',
      time_spent: 'Time spent',
      title: "{name}'s progress",
      top_activities_title: 'Most played',
      track_percent: '{n}% of the track',
      view: 'View progress',
      xp: 'XP earned',
      xp_total: '{n} total',
      xp_week: '{n} this week',
    },
    pwa: {
      install_body: 'Add it to your home screen for the full app.',
      install_cta: 'Install',
      install_dismiss: 'Not now',
      install_title: 'Install Fajr Arabi',
    },
    school: {
      add_class: 'Add class',
      add_student: 'Add student',
      add_to_class: 'Add to class',
      admin_name: 'Your name',
      class_name: 'Class name',
      classes_title: 'Classes',
      coming_soon: 'Teacher management, classes, and billing arrive with the schools release.',
      country: 'Country',
      create: 'Create',
      create_account: 'Create school account',
      dashboard_title: 'School management',
      grade: 'Grade',
      have_account: 'Already have an account? Sign in',
      invite_accept: 'Set password & join',
      invite_invalid: 'This invitation link is invalid or has expired.',
      invite_join_title: 'Join {school}',
      invite_sent: 'Invitation sent',
      invite_teacher: 'Invite teacher',
      no_class_option: 'No class',
      no_classes: 'No classes yet. Create your first class.',
      no_students: 'No students yet. Add your first student.',
      no_teachers: 'No teachers yet. Invite your first teacher.',
      overview_subtitle: 'Manage your teachers, classes and students.',
      remove: 'Remove',
      reset_password: 'Reset password',
      school_name: 'School name',
      send_invite: 'Send invite',
      signup_subtitle: 'Create a school account to invite teachers and enrol students.',
      signup_title: 'Register your school',
      stat_classes: 'Classes',
      stat_students: 'Students',
      stat_teachers: 'Teachers',
      status_active: 'Active',
      status_invited: 'Invited',
      student_count: '{n} students',
      student_name: 'Name',
      student_password: 'Password',
      student_username: 'Username',
      students_title: 'Students',
      teacher: 'Teacher',
      teacher_email: 'Email',
      teacher_name: 'Name',
      teachers_title: 'Teachers',
      unassigned: 'Unassigned',
      username_free: 'Available',
      username_taken: 'That username is taken',
      welcome: 'Welcome, {name}',
    },
    tasks: {
      create: 'Create task',
      due_date: 'Due date',
      due_prefix: 'Due',
      empty_teacher: 'No tasks yet. Create one above.',
      mark_done: "I'm done",
      my_empty: 'No tasks right now. Great job!',
      my_title: 'My tasks',
      pick_class: 'Class',
      remove: 'Remove',
      reopen: 'Reopen',
      status_done: 'Done',
      status_in_progress: 'In progress',
      status_open: 'Open',
      status_verified: 'Verified',
      title: 'Tasks',
      title_label: 'Task',
      title_placeholder: 'e.g. Bring a story to share on Sunday',
      verify: 'Verify',
    },
    teacher: {
      assign: 'Assign',
      assign_lesson: 'Assign lesson',
      assignments_title: 'Assignments',
      classes_title: 'My classes',
      coming_soon: 'Classes, rosters, and assignments arrive with the schools release.',
      dashboard_title: 'Your classroom',
      due_date: 'Due date (optional)',
      lessons_done: '{n} lessons',
      no_assignments: 'No assignments yet. Assign a lesson to a class.',
      no_classes: 'No classes assigned to you yet. Ask your school admin to assign one.',
      no_students: 'No students in this class yet.',
      overview_subtitle: 'Your classes, students and assignments.',
      pick_class: 'Class',
      pick_lesson: 'Lesson',
      roster: 'Roster',
      unassign: 'Unassign',
      view_progress: 'Progress',
      welcome: 'Welcome, {name}',
    },
  },
  badge: {
    first_lesson: {
      description: 'You finished your very first lesson.',
      title: 'First steps',
    },
    five_lessons: {
      description: 'Five lessons done. Keep it up!',
      title: 'Getting going',
    },
    five_perfect: {
      description: 'Five perfect lessons. Impressive!',
      title: 'Sharp mind',
    },
    perfect_lesson: {
      description: 'You scored 100 on a lesson.',
      title: 'Perfect score',
    },
    streak_3: {
      description: 'You learned three days in a row.',
      title: 'Three in a row',
    },
    streak_30: {
      description: 'Thirty days in a row. Amazing dedication.',
      title: 'Unstoppable',
    },
    streak_7: {
      description: 'Seven days of learning in a row!',
      title: 'A full week',
    },
    twenty_lessons: {
      description: 'Twenty lessons — you have come a long way.',
      title: 'Explorer',
    },
    unit_master: {
      description: 'You finished every lesson in a unit.',
      title: 'Unit master',
    },
    xp_100: {
      description: 'You earned your first 100 XP.',
      title: 'Century',
    },
    xp_500: {
      description: 'Five hundred XP earned!',
      title: 'Champion',
    },
  },
  content: {
    common: {
      captions: 'Captions',
      listen_choose: 'Listen, then choose',
      play_audio: 'Play sound',
      quiz_title: 'Quick check',
      tap_match: 'Match each pair',
    },
    drag_sort: {
      all_sorted: 'All sorted!',
      instruction: 'Sort each word into the right group',
    },
    fill_blank: {
      blank_label: 'Missing word',
      instruction: 'Fill in the blanks',
    },
    letter_trace: {
      canvas_label: 'Trace the letter {glyph}',
      clear: 'Clear',
    },
    player: {
      back_home: 'Back to home',
      continue: 'Continue',
      correct: 'Well done!',
      done_subtitle: 'You did a great job today.',
      done_title: 'Lesson complete!',
      empty: 'This lesson has no activities yet.',
      error: "Couldn't save that. Tap to try again.",
      exit: 'Exit lesson',
      finish: 'Finish',
      saving: 'Saving…',
      stat_score: 'Score',
      stat_streak: 'Streak',
      stat_xp: 'XP',
      streak_days: '{n} days',
      try_again_feedback: 'Not quite — keep going!',
    },
    printable: {
      download: 'Download worksheet',
    },
    read_aloud: {
      mode_partial: 'Some',
      mode_with: 'Full',
      mode_without: 'None',
      tashkeel_label: 'Diacritics',
    },
    record_repeat: {
      again: 'Record again',
      playback: 'Play my recording',
      say_this: 'Say this out loud',
      start: 'Record',
      stop: 'Stop',
      unsupported: 'Recording isn’t available here — that’s okay, tap Continue.',
    },
    story_scene: {
      new_words: 'New words',
    },
  },
  notif: {
    message_broadcast_body: '{sender} posted to your class.',
    message_broadcast_title: 'Class announcement',
    message_observed_body: '{sender} sent a message in your child’s conversation.',
    message_observed_title: 'New message for your child',
    message_received_body: '{sender} sent you a message.',
    message_received_title: 'New message',
    task_assigned_body: 'You have a new task: {title}',
    task_assigned_title: 'New task',
    task_completed_body: 'A student marked “{title}” as done.',
    task_completed_title: 'Task completed',
  },
  plan: {
    family_free_name: 'Free',
    family_free_tagline: 'Free lessons, one child, no card needed.',
    family_name: 'Family',
    family_plus_name: 'Family+',
    family_plus_tagline: 'Everything, plus a monthly live session.',
    family_starter_name: 'Starter',
    family_starter_tagline: 'One child, Arabic essentials.',
    family_tagline: 'Up to 4 kids, every subject.',
    feat: {
      '1500_students': 'Up to 1,500 students',
      '150_students': 'Up to 150 students',
      '20_teachers': '20 teachers',
      '500_students': 'Up to 500 students',
      '5_teachers': '5 teachers',
      all_subjects: 'All subjects',
      arabic_only: 'Arabic curriculum',
      basic_dashboards: 'Basic dashboards',
      custom_curriculum: 'Custom curriculum mapping',
      dedicated_csm: 'Dedicated success manager',
      four_kids: 'Up to 4 children',
      free_lessons: 'Free lessons',
      full_teacher_tools: 'Full teacher tools',
      live_session: 'Monthly live session',
      one_child: '1 child',
      printables: 'Printable worksheets',
      priority_support: 'Priority support',
      progress: 'Progress dashboard',
      white_label: 'White-label portal',
    },
    school_premium_name: 'School Premium',
    school_premium_tagline: 'White-label, custom curriculum.',
    school_standard_name: 'School Standard',
    school_standard_tagline: 'Up to 500 students, full tools.',
    school_starter_name: 'School Starter',
    school_starter_tagline: 'Up to 150 students.',
  },
  ui: {
    auth: {
      sign_in: 'Sign in',
    },
    brand: {
      product_name: 'Fajr Arabi',
      tagline: 'Arabic, brought to life for children',
    },
    language: {
      arabic: 'العربية',
      english: 'English',
      switch: 'Change language',
    },
  },
} as const;

export default en;
